let email = "processportal@digitalalign.com";
let accessKey = "Ncv0Zo!b3ofi3e$&I9!eldCaO2Rv&mW$BTpi8MeMPgDj$ysSKUqUO7WePX@Ztqp2";
export default {
    email: email,
    accessKey: accessKey
}